export default __webpack_public_path__ + "static/media/DreamJobs1_08.6abfd43e.png";